package org.hs_soft.runmynesto.data.api_datasource.dashboard

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient

import org.hs_soft.runmynesto.domain.model.home.dashboard.get_shop_statics.ShopStaticModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.dashboard.ShopStaticsRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.config.Errors


class ShopStaticsRepositoryImpl (
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): ShopStaticsRepository {

    override suspend fun getShopStatics(
        date: String,
    ):ShopStaticModel
    {
        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put(
                "query", """
                    query Query(${'$'}date: String!) { 
                        getShopsStatisticForDate(date: ${'$'}date) {
                          branchId
                          branchName
                          statData {
                            operations {
                              ${ApiUtils.Field.caption}
                              ${ApiUtils.Field.count}
                              ${ApiUtils.Field.total}
                              ${ApiUtils.Field.type}
                            }
                            ${ApiUtils.Field.revenueChangePct}
                            timeIntervals {
                              ${ApiUtils.Field.amount}
                              ${ApiUtils.Field.timeInterval}
                            }
                            topArticlesByCount {
                              ${ApiUtils.Field.id}
                              ${ApiUtils.Field.name}
                              ${ApiUtils.Field.number}
                              ${ApiUtils.Field.value}
                            }
                            topArticlesByTotal {
                              ${ApiUtils.Field.id}
                              ${ApiUtils.Field.name}
                              ${ApiUtils.Field.number}
                              ${ApiUtils.Field.value}
                            }
                            ${ApiUtils.Field.totalRevenue}
                          }
                        } 
                    }
                """.trimIndent()
            )
            
            putJsonObject("variables") {
                put("date", date)
            }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.KOTLIN_API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }
}

